import { resolveAppMountBase } from './mountBase'

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) {
    return null
  }

  // Defer registration until page is fully loaded to avoid "invalid state" errors
  // that occur when the <base> tag hasn't settled yet
  if (document.readyState !== 'complete') {
    return new Promise((resolve) => {
      window.addEventListener('load', () => resolve(doRegister()), { once: true })
    })
  }
  return doRegister()
}

async function doRegister(): Promise<ServiceWorkerRegistration | null> {
  try {
    // The current route can be arbitrarily deep (/account/profile). Register
    // against the platform mount, not that route's directory.
    const mountBase = resolveAppMountBase(window.location.pathname)
    const scope = `${mountBase || ''}/`
    const swUrl = `${scope}sw.js`
    const registration = await navigator.serviceWorker.register(swUrl, { scope })
    console.log('[PWA] Service worker registered, scope:', registration.scope)
    return registration
  } catch (error) {
    console.error('[PWA] Service worker registration failed:', error)
    return null
  }
}
